import { Path, Rect, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Rect x="9" y="9" width="6" height="11" fill="currentColor" stroke="none" />
		<Path d="M4 4.75H20" />
	</SVG>
);
